import React, { useState, useEffect, useMemo } from "react";
import { UploadFile, DownloadPreview, ToDataSource, StartBrowserOpenUrl } from "../logic/BosFileTransfer";
import * as BosFilesServices from "data/BosWebServices/BosFilesServices";
import * as Constants from "../logic/Constants";
//import ContentLoading from "../../components/ContentLoading";
import FileDragAndDrop from "../../components/FileDragAndDrop";
import { FloatingLabelContainer } from "../../components/FloatingLabel";

// Externals
import cn from "classnames";

// DevExtreme components
import { TextBox } from 'devextreme-react';
import { Button as TextBoxButton } from 'devextreme-react/text-box';

// Component styles
import classes from "./SimpleDMSWidget.module.scss";

export function SimpleDMSWidget(props) {
  const { ui, data, writeBack, dataSegment, useFloatingLabel } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  let fileInputSelector;

  let widgetId = ui.id;
  let disabled = ui.readonly || (data && data.readonly);

  let content = data && data.content ? JSON.parse(data.content) : "";
  let displayContent = content && content.FileName ? content.FileName : "";
  let valueContent = content && content.FileId ? content.FileId : "";
  let enabledActions = content ? content.EnabledActionIds : [];

  useEffect(() => {
    function fetchData() {
      DownloadPreview(valueContent, dataSegment.authToken)
        .then(result => {
          console.log("DownloadPreview result: ", result);
          let img = ToDataSource(result.content, result.contentType);
          setPreviewImage(img);
        })
        .catch(error => {
          console.error("DownloadPreview result: ", error);
          setPreviewImage();
        });
    }
    //console.log("SimpleDMSWidget data of " + ui.id + ": ", data);
    if (valueContent)
      fetchData();
    else
      setPreviewImage();
  }, [data]);

  const filePreviewButtonOptionsMemo = useMemo(() => {
    return {
      icon: previewImage,
      stylingMode: 'text',
      onClick: (e) => handleOpenDocumentOnClick(e)
    };
  }, [previewImage]);

  const attachFileButtonOptionsMemo = useMemo(() => {
    return {
      icon: 'file',
      stylingMode: 'text',
      onClick: (e) => handleAttachNewDocumentClick(e)
    };
  }, [previewImage]);

  const handleAttachNewDocumentClick = (event) => {
    fileInputSelector.click();
  };

  const handleOpenDocumentOnClick = (event) => {
    let fileId = valueContent;
    if (fileId) {
      console.log("Downloading file", fileId);
      setIsLoading(true);
      let fileUrl = BosFilesServices.getProtectedWebResourceUrl(dataSegment.authToken, fileId);
      StartBrowserOpenUrl(fileUrl);
      setIsLoading(false);
    }
  };

  const handleFileSelected = (event) => {
    event.preventDefault();
    uploadDocument(event.target.files);
  };

  const uploadDocument = (files) => {
    let selectedFile = files ? (files.length > 0 ? files[0] : null) : null;
    if (selectedFile) {
      console.log("Uploading selected file", selectedFile);
      setIsLoading(true);
      UploadFile(selectedFile, dataSegment.authToken, dataSegment.id)
        .then(fileId => {
          console.log("Upload result: ", fileId);
          let value = JSON.stringify({ FileId: fileId });
          writeBack(value, true);
          setIsLoading(false);
        })
        .catch(error => {
          console.error("Upload result: ", error);
          setIsLoading(false);
        });
    }
    else {
      console.log("No file selected -> nothing to upload");
    }
  };

  const isActionAllowed = actionId => {
    return enabledActions.includes(actionId);
  };

  const handleFileDrop = (files) => {
    uploadDocument(files);
  };

  const renderFilePreviewButton = () => {
    return (
      <TextBoxButton
        name="filePreviewButton"
        location="before"
        options={filePreviewButtonOptionsMemo}
        disabled={!isActionAllowed(Constants.DOCUMENT_WIDGET_DOWNLOAD_ACTION)}
      />
    );
  };

  const renderAttachFileButton = () => {
    return (
      <TextBoxButton
        name="attachFileButton"
        location="after"
        options={attachFileButtonOptionsMemo}
        disabled={false}
      >
      </TextBoxButton>
    );
  };

  //TODO: show loadingIndicator while uploading a new file

  return (
    <FileDragAndDrop disabled={disabled || !isActionAllowed(Constants.DOCUMENT_WIDGET_UPLOAD_ACTION)} handleDrop={handleFileDrop} style={{ height: "100%", width: "100%" }}>
      <FloatingLabelContainer condition={useFloatingLabel} widgetId={widgetId} hasContent={valueContent} text={ui.label}>
        <TextBox
          id={widgetId}
          className={cn(disabled ? classes.disabled : "")}
          style={{ textDecoration: "underline" }}
          value={displayContent}
          disabled={disabled}
          inputAttr={{ disabled: true }}
          height={ui.controlHeight + "em"}
        >
          {previewImage
            ? renderFilePreviewButton()
            : null
          }
          {disabled || isLoading || !isActionAllowed(Constants.DOCUMENT_WIDGET_UPLOAD_ACTION)
            ? null
            : renderAttachFileButton()
          }
        </TextBox>
      </FloatingLabelContainer>

      {/* INVISIBLE FILE UPLOAD INPUT */}
      <input type="file" multiple={false} accept="*/*" ref={el => fileInputSelector = el} onChange={(e) => handleFileSelected(e)} style={{ display: "none" }} />

    </FileDragAndDrop>
  );
}
